// removed by extract-text-webpack-plugin
module.exports = {"container":"_2BPD","wrapper":"_1XIr","copy":"_2e5s","copyDescription":"_2L1d"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Hero/styles.scss
// module id = 302
// module chunks = 0